const appConfig = {
  botLink: process.env.REACT_APP_BOT_LINK,
  promoBonus: process.env.REACT_APP_REFERRAL_BONUS,
  apiUrl: process.env.REACT_APP_API_URL,
  thiefCooldown: process.env.REACT_APP_THIEF_COOLDOWN,
  fightCooldown: process.env.REACT_APP_FIGHT_COOLDOWN,
};

export { appConfig };
